import { render, staticRenderFns } from "./b-radio-tab.vue?vue&type=template&id=39d3c9be&scoped=true"
import script from "./b-radio-tab.vue?vue&type=script&lang=js"
export * from "./b-radio-tab.vue?vue&type=script&lang=js"
import style0 from "./b-radio-tab.vue?vue&type=style&index=0&id=39d3c9be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d3c9be",
  null
  
)

export default component.exports